import React from 'react';
import styled, { FlattenSimpleInterpolation } from 'styled-components';
import tw from 'tailwind.macro';
import { P2 } from '../../Typographies/Paragraph';

type TLabelPlacement = 'start' | 'end' | 'top';

interface ContainerProps {
  labelPlacement: TLabelPlacement;
  isHighlighted?: boolean;
  spaceBetween?: boolean;
  customStyle?: FlattenSimpleInterpolation;
}

const LabelWrapper = styled(P2)<{ customStyle?: FlattenSimpleInterpolation }>`
  ${tw`flex-1 py-small w-full`}
  ${({ customStyle }) => customStyle}
`;

const Container = styled.label<ContainerProps>`
  ${tw`flex items-center px-medium  cursor-pointer`}
  gap: var(--size-small);

  & input:disabled + ${LabelWrapper} {
    ${tw`text-grey-300 cursor-not-allowed`}
  }

  ${({ labelPlacement }) => {
    switch (labelPlacement) {
      case 'start':
        return tw`flex-row-reverse justify-end`;
      case 'end':
        return;
      case 'top':
        return tw`flex-col-reverse items-start`;
      default:
        return;
    }
  }}

  ${({ spaceBetween }) => spaceBetween && tw`justify-between w-full`}

  ${({ isHighlighted }) => isHighlighted && tw`bg-grey-200`}

  ${({ customStyle }) => customStyle}
`;

interface FieldLabelControlProps {
  control: React.ReactNode;
  label: React.ReactNode;
  labelPlacement: TLabelPlacement;
  spaceBetween?: boolean;
  isHighlighted?: boolean;
  customStyle?: FlattenSimpleInterpolation;
  labelWrapperCustomStyle?: FlattenSimpleInterpolation;
  id?: string;
}

const FieldLabelControl: React.FC<FieldLabelControlProps> = ({
  control,
  customStyle,
  id,
  isHighlighted,
  label,
  labelPlacement,
  labelWrapperCustomStyle,
  spaceBetween,
}) => (
  <Container
    customStyle={customStyle}
    id={id}
    isHighlighted={isHighlighted}
    labelPlacement={labelPlacement}
    spaceBetween={spaceBetween}
  >
    {control}
    <LabelWrapper as="div" customStyle={labelWrapperCustomStyle}>
      {label}
    </LabelWrapper>
  </Container>
);

export default FieldLabelControl;
